export let constants = {
	projectTitle: 'Just Culture Decision Support Tool',
	mainContent508Id: '508-main-content',
	debugMode: false,
	design: {
		hoverColor1: 'rgb(83, 103, 149)',
		hoverColor2: 'rgb(159, 191, 211)' //submit button
	},
	uiTags: {
		Hud: 'Hud'
	},
	uiNames: {
		TopLeftControlsUI: 'TopLeftControlsUI',
		ResumeUI: 'ResumeUI',
		ReturnToMainMenuUI: 'ReturnToMainMenuUI',
		QuestionType1UI: 'QuestionType1UI',
		FeedbackUI: 'FeedbackUI',
		QuestionType2UI: 'QuestionType2UI',
		AlertUI: 'AlertUI',
		SkipContentUI: 'SkipContentUI',
		IntroScreenUI: 'IntroScreenUI',
		MixedMediaUI: 'MixedMediaUI',
		ScenarioInfoUI: 'ScenarioInfoUI',
		LoadingUI: 'LoadingUI',
	},
};